export const getUrlParam = paramName => {
    const params = location.search.substr(1).split('&');
    for (let param in params) {
        const arr = params[param].split('=');
        if (arr[0] === paramName) {
            return decodeURIComponent(arr[1]);
        }
    }
};